import { useTranslation } from "react-i18next";
import { resolveMediaUrl } from "../../../../utility/media";
import { IoClose } from "react-icons/io5";

const ViewEmployeeDetailsModalComponent = ({ isOpen, onClose, employee }) => {
  const { t } = useTranslation();

  if (!isOpen || !employee) return null;

  return (
    <div className="staff-modal-overlay">
      <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
        {/* Header Bar matching image_f49878.png styling */}
        <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
          <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
            {t('pageTitles.employeeDetails')}
          </div>
          <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
            <IoClose />
          </button>
        </div>

        <div className="staff-form-body p-8 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-start">

            {/* Left: Photo Section (Spans 2 columns) */}
            <div className="md:col-span-2 flex justify-center">
              <div className="relative">
                {employee.photoUrl ? (
                  <img
                    src={resolveMediaUrl(employee.photoUrl)}
                    alt={employee.name}
                    className="w-64 h-64 object-cover rounded-2xl border-2 border-blue-600 shadow-sm"
                  />
                ) : (
                  <div className="w-64 h-64 flex items-center justify-center border-2 border-blue-600 rounded-2xl bg-gray-50 text-gray-400">
                    <span className="text-sm">{t('common.noFile')}</span>
                  </div>
                )}
              </div>
            </div>

            {/* Right: Details Section (Spans 3 columns) */}
            <div className="md:col-span-3 pt-4">
              <div className="space-y-3">
                <DetailRow label={t('forms.employee.fullName')} value={employee.name} />
                <DetailRow label={t('forms.employee.employeeNumber')} value={employee.employeeNumber} />
                <DetailRow label={t('forms.employee.contactPrimary')} value={employee.contactPrimary} />
                <DetailRow label={t('forms.employee.contactSecondary')} value={employee.contactSecondary} />
                <DetailRow label={t('forms.employee.email')} value={employee.email} />
                <DetailRow label={t('forms.employee.department')} value={employee.departmentName} />
                <DetailRow label={t('forms.employee.panNo')} value={employee.panNo} />
                <DetailRow label={t('forms.employee.aadhaarNo')} value={employee.aadhaarNo} />
              </div>
            </div>

          </div>
        </div>

        {/* Footer with standard close button */}
        <div className="staff-form-footer">
          <button className="staff-btn-save" onClick={onClose}>
            {t('common.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

// Helper component for the aligned rows (Label : Value)
const DetailRow = ({ label, value }) => (
  <div className="grid grid-cols-12 gap-2 text-sm">
    <span className="col-span-5 text-right text-gray-700 font-medium">{label}</span>
    <span className="col-span-1 text-center font-bold text-gray-900">:</span>
    <span className="col-span-6 text-left font-bold text-gray-900">
      {value || "—"}
    </span>
  </div>
);

export default ViewEmployeeDetailsModalComponent;